import * as React from 'react';
import { useEffect, useContext, useState } from "react";
import Box from '@mui/material/Box';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import CircularProgress from '@mui/material/CircularProgress';
import {
  DataGridPro,
  GridActionsCellItem,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
  esES,
} from '@mui/x-data-grid-pro';
import Zoom from "react-medium-image-zoom";
import { CajasContext } from "src/context/CajasContext/CajasContext";
import { Tooltip, Chip } from "@mui/material";
import ImageIcon from '@mui/icons-material/Image';
import { SimpleDialogComponent } from "../../../../general_components/SimpleDialogComponent";
import { Grid, Typography } from "@mui/material";
import Button from '@mui/material/Button';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Stack from '@mui/material/Stack';
import { IconButton } from '@mui/material';
import { TipoContenidosSelectMetadatos } from './TipoContenidosSelectMetadatos';
import { SnackbarMessenger } from "src/general_components/SnackbarMessenger";
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import { GroupedMetadataTable } from "src/projects/gestion_documental/components/Digitalizaciones/GroupedMetadataTable";
import { estilosComponentGrilla } from 'src/general_components/FunctionsListTablePaginated';
import { actualizarContadorEstadisticas } from "src/general_helpers/EstadisticasData";

export const FullFeaturedCrudGrid = (props) => {
  const {
    tipoContenidoList,
    setUpdateImageSave,
    updateImageSave,
    setAlertDelete,
    setIndex,
    // disabledTipoContenidoSelect,
    nameFolioLote,
    nro_folio_cuentas_parametros_value,
    ocrResultados,
    ocrUmbral,
    onOcrApply,
    onOcrSingleExtract,
    ocrSingleLoading,
  } = props;


  // eslint-disable-next-line no-unused-vars
  const [initialLoadingState, setInitialLoadingState] = React.useState(true);
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = React.useState(initialLoadingState);
  const [funcionChangeCheckbox, setFuncionChangeCheckbox] = React.useState(false);

  const [desplegarImagen, setDesplegarImagen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [modalStateContenidosForm, setModalStateContenidosForm] = useState(false);
  const [tipoContenidoSelect, setTipoContenidoSelect] = useState(false);
  const [registroSeleccionado, setRegistroSeleccionado] = useState(false);
  const [snackbarVisible, setSnackbarVisible] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [ocrCamposModal, setOcrCamposModal] = useState([]);


  const {
    rows, setRows, checkedTotal, digitalizacionesSeleccionadas, digitalizacionesSeleccionadasCompleto, setDigitalizacionesSeleccionadas,
    checkedTotalCaratula, setDigitalizacionesSeleccionadasCompleto,
    ocrMode
  } = useContext(CajasContext);

  const [rowModesModel, setRowModesModel] = React.useState({});
  const user_data = JSON.parse(localStorage.getItem("siam-user-data"));
  const id_perfil_usuario = user_data?.id_perfiles;

  const handleImageClick = async (imageUrl) => {
    const estatCheck = await actualizarContadorEstadisticas("consultas");
    if (!estatCheck.permitido) {
      setSnackbarVisible(true);
      setMessage(estatCheck.message);
      setSeverity("error");
      return;
    }
    setDesplegarImagen(true);
    setSelectedImage(imageUrl);
  };


  const handleCloseImage = () => {
    setDesplegarImagen(false);

  };

  const handleDeleteClick = (id) => () => {
    setAlertDelete(true);
    let index = rows.findIndex(function (row) {
      // eslint-disable-next-line eqeqeq
      return row.id == id; // or el.nombre=='T NORTE';
    });
    setIndex(index);

  };

  const nro_folio_inicial = nro_folio_cuentas_parametros_value ?? 1;
  function updateRowPosition(initialIndex, newIndex, rows, nro_folio_inicial = 1) {
    return new Promise((resolve) => {
      setTimeout(() => {
        const rowsClone = [...rows];
        const row = rowsClone.splice(initialIndex, 1)[0];
        rowsClone.splice(newIndex, 0, row);

        // Determinar el valor inicial
        const folioBase = nro_folio_inicial != null ? parseInt(nro_folio_inicial, 10) : 1;

        for (let i = 0; i < rowsClone.length; i++) {
          const folio = folioBase + i;
          rowsClone[i].folio = folio;
          if (rowsClone[i].model_data) {
            rowsClone[i].model_data.folio = folio;
          }
        }

        resolve(rowsClone);
      }, Math.random() * 500 + 100); // simulate network latency
    });
  }


  const handleRowOrderChange = async (params) => {
    setLoading(true);
    const newRows = await updateRowPosition(
      params.oldIndex,
      params.targetIndex,
      rows,
      nro_folio_inicial
    );

    let rowsOrderEdit = updateImageSave;

    for (let i = 0; i < newRows.length; i++) {
      if (newRows[i].save) {
        rowsOrderEdit = {
          ...rowsOrderEdit,
          [newRows[i].id_digitalizaciones]: {
            ...rowsOrderEdit[newRows[i].id_digitalizaciones],
            folio: newRows[i].folio.toString(),
            id: newRows[i].id_digitalizaciones,
          },
        };
      }
    }

    setUpdateImageSave(rowsOrderEdit);
    setRows(newRows);
    setLoading(false);
  };

  React.useEffect(() => {
    setLoading(!initialLoadingState);
  }, [initialLoadingState]);


  useEffect(() => {
    setFuncionChangeCheckbox(true);
    const newROws = rows.map((valorActual, indice, arr) => {
      let rowConvertido = { ...valorActual, checked: checkedTotal }
      return rowConvertido;
    });
    let digitalizacionesContenidosSeleccionadasFiltradas = newROws.filter((item) => item.id_digitalizaciones && item.checked !== false);
    let digitalizacionesContenidosSeleccionadasTotal = digitalizacionesContenidosSeleccionadasFiltradas.map(function (obj) {
      return obj.id_digitalizaciones;
    });
    let digitalizacionContPrevio = [...digitalizacionesSeleccionadasCompleto.digitalizaciones_contenidos];
    if (digitalizacionesContenidosSeleccionadasFiltradas.length < 1) {
      for (var i = 0; i < rows.length; i++) {
        // eslint-disable-next-line no-loop-func
        digitalizacionContPrevio = digitalizacionContPrevio.filter((item) => item !== rows[i].id_digitalizaciones)
      }
    }
    let digitalizacionContFinal = digitalizacionContPrevio.concat(digitalizacionesContenidosSeleccionadasTotal);
    let contenidoDigitalizacionesUnicos = Array.from(new Set(digitalizacionContFinal))
    setDigitalizacionesSeleccionadas({ ...digitalizacionesSeleccionadas, contenidos: contenidoDigitalizacionesUnicos })
    // Convertimos el arreglo en string
    const str = JSON.stringify(digitalizacionesSeleccionadas);
    // Parseamos el string a un arreglo
    const digitalizacionesSel = JSON.parse(str);
    digitalizacionesSel['digitalizaciones_contenidos'] = contenidoDigitalizacionesUnicos;
    setDigitalizacionesSeleccionadas(digitalizacionesSel)
    setDigitalizacionesSeleccionadasCompleto(digitalizacionesSel)
    setRows(newROws)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkedTotalCaratula]);


  useEffect(() => {
    if (rows.length > 0 && !funcionChangeCheckbox) {
      const newROws = rows.map((valorActual, indice, arr) => {
        const idDigitalizacionEncontrado = digitalizacionesSeleccionadasCompleto.digitalizaciones_contenidos.find(element => element === valorActual.id_digitalizaciones);
        if (idDigitalizacionEncontrado) {
          let rowConvertido = { ...valorActual, checked: true }
          return rowConvertido;
        } else {
          let rowConvertido = { ...valorActual }
          return rowConvertido;
        }

      });
      // selectedDigitalizaciones(newROws)
      let digitalizacionesContenidosSeleccionadasFiltradas = newROws.filter((item) => item.id_digitalizaciones && item.checked !== false);
      let digitalizacionesContenidosSeleccionadasTotal = digitalizacionesContenidosSeleccionadasFiltradas.map(function (obj) {
        return obj.id_digitalizaciones;
      });
      //         // Convertimos el arreglo en string
      const str = JSON.stringify(digitalizacionesSeleccionadas);
      // // Parseamos el string a un arreglo
      const digitalizacionesSel = JSON.parse(str);
      digitalizacionesSel['digitalizaciones_contenidos'] = digitalizacionesContenidosSeleccionadasTotal;
      setDigitalizacionesSeleccionadas(digitalizacionesSel)
      // setRows(newROws)
    }
    setFuncionChangeCheckbox(false);


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rows]);

  const columns = [
    {
      field: "id_digitalizaciones",
      headerName: "ID Digitalizacion",
      hide: true,
      sortable: false
    },
    {
      field: "image",
      headerName: "Imagen",
      width: 170,
      height: 750,
      sortable: false,
      editable: true,
      renderEditCell: (params) => (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          minHeight: 150 // Ajusta la altura mínima de la celda según sea necesario
        }}><Zoom isZoomed={true} key={params.id}>
            <img src={params.value} style={{ maxWidth: '100%', maxHeight: '100%', borderRadius: '5px' }} alt="Full Size" />
          </Zoom></div>),
      renderCell: (params) => (
        <Zoom isZoomed={true} key={params.id}>
          <div style={{
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%'
          }} onClick={() => handleImageClick(params.value)}>
            <ImageIcon style={{ width: '30%', height: '30%' }} />
          </div>
        </Zoom>
      )
      // eslint-disable-next-line jsx-a11y/alt-text
      // renderCell: (params) => (<Zoom isZoomed={true} key={params.id}> <img src={params.value} /> </Zoom>)
    }, {
      field: "folio",
      headerName: nameFolioLote ? nameFolioLote : "Nro. Imagen",
      hide: false,
      flex: 0.5
    },
    {
      field: "tipo_contenidos",
      headerName: "Tipo Contenido",
      hide: false,
      flex: 1,
      editable: false,
    },
    {
      field: "meta_datos_concat",
      headerName: "Valores Metadatos",
      flex: 4,
      headerAlign: "center",
      renderCell: (params) => {
        const metadatos = params.row.meta_datos;
        return (
          metadatos && metadatos.length > 0 ? (
            <GroupedMetadataTable metadatos={metadatos} groupSize={2} />
          ) : null
        );
      }
    },

    // Las siguientes columnas se ocultarán si id_perfil_usuario es igual a 6
    ...(id_perfil_usuario !== "9" ? [
      {
        field: 'id',
        headerName: 'Metadatos',
        headersAlign: 'center',
        flex: 0.5,
        editable: false,
        renderCell: (params) => {
          let value = tipoContenidoList.find(objeto => objeto.id === params.row.id_tipo_contenidos);
          const cantidad_metadatos =
            Array.isArray(params.row.meta_datos) && params.row.meta_datos.length > 0
              ? params.row.meta_datos.filter((m) => m.valor !== "" && m.id !== "").length
              : 0;

          const rowIndex = rows.findIndex(r => r.id === params.row.id);
          const ocrDeEstaFila = (ocrResultados || []).filter(r => r.docIndex === rowIndex);
          // Solo los campos mapeados a un metadato pueden aplicarse
          const ocrMapeados = ocrDeEstaFila.filter(r => r.id_metadatos);
          const tieneOcr = ocrDeEstaFila.length > 0;
          const todosAplicados = ocrMapeados.length > 0 && ocrMapeados.every(r => r.applied);
          const algunoAplicado = ocrMapeados.length > 0 && ocrMapeados.some(r => r.applied) && !todosAplicados;

          return (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '100%',
                gap: 0.5,
              }}
            >
              <Tooltip title="Ver metadatos" arrow>
                <IconButton
                  color={cantidad_metadatos > 0 ? "primary" : "error"}
                  onClick={() => {
                    const ocrCamposRow = (ocrResultados || [])
                      .map((r, idx) => ({ ...r, globalIdx: idx }))
                      .filter(r => r.docIndex === rowIndex);
                    setOcrCamposModal(ocrCamposRow);
                    setRegistroSeleccionado(params.row);
                    setTipoContenidoSelect(value);
                    toggleModalContenidosForm(params);
                  }}
                >
                  <FormatListNumberedIcon />
                </IconButton>
              </Tooltip>
              <Typography
                variant="caption"
                sx={{
                  color: cantidad_metadatos > 0 ? "text.primary" : "error.main",
                  textAlign: "center",
                  width: "100%",
                }}
              >
                {cantidad_metadatos === 0
                  ? "Sin metadatos"
                  : cantidad_metadatos + " cargado" + (cantidad_metadatos !== 1 ? "s" : "")}
              </Typography>
              {tieneOcr && (
                <Tooltip title={
                  todosAplicados
                    ? "OCR aplicado completamente"
                    : algunoAplicado
                      ? `OCR: ${ocrDeEstaFila.filter(r => r.applied).length}/${ocrDeEstaFila.length} aplicados`
                      : `OCR escaneado: ${ocrDeEstaFila.length} campo${ocrDeEstaFila.length !== 1 ? "s" : ""} pendientes`
                }>
                  <Chip
                    label={todosAplicados ? "OCR ✓" : algunoAplicado ? "OCR parcial" : "OCR listo"}
                    size="small"
                    color={todosAplicados ? "success" : algunoAplicado ? "warning" : "info"}
                    variant={todosAplicados ? "filled" : "outlined"}
                    sx={{ fontSize: '0.65rem', height: 18 }}
                  />
                </Tooltip>
              )}
            </Box>
          );
        },
      },
      {
        field: 'actions',
        type: 'actions',
        headerName: 'Acciones',
        width: 150,
        cellClassName: 'actions',
        getActions: (params) => {
          let id = params.id;
          const rowIndex = rows.findIndex(r => r.id === id);
          const isScanning = ocrSingleLoading && ocrSingleLoading[rowIndex];
          const hasImage = !!params.row.image;

          const actions = [
            <GridActionsCellItem
              icon={<Tooltip title="Eliminar"><DeleteIcon color="error" /></Tooltip>}
              label="Delete"
              onClick={handleDeleteClick(id)}
            />,
          ];

          if (ocrMode && onOcrSingleExtract) {
            actions.unshift(
              <GridActionsCellItem
                icon={
                  <Tooltip title={!hasImage ? 'Sin imagen para escanear' : 'Escanear imagen con OCR'}>
                    {isScanning
                      ? <CircularProgress size={18} color="secondary" />
                      : <DocumentScannerIcon color={hasImage ? "secondary" : "disabled"} />
                    }
                  </Tooltip>
                }
                label="Escanear OCR"
                disabled={!hasImage || isScanning}
                onClick={() => onOcrSingleExtract(rowIndex)}
              />
            );
          }

          return actions;
        },
      }
    ] : []),
  ];

  const handleDownload = async (urlImg, descripcion) => {
    const estatCheck = await actualizarContadorEstadisticas("descargas");
    if (!estatCheck.permitido) {
      setSnackbarVisible(true);
      setMessage(estatCheck.message);
      setSeverity("error");
      return;
    }
    const nombreArchivo = urlImg.split('/').pop();
    try {
      const response = await fetch(urlImg);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const blob = await response.blob();
      const imageUrl = URL.createObjectURL(blob); // Crea una URL de objeto
      const link = document.createElement('a');
      link.href = imageUrl;
      link.target = '_blank'; // Abre el enlace en una nueva pestaña
      link.download = !descripcion || descripcion === "" ? nombreArchivo : descripcion; // Nombre con el que se descargará la imagen
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(imageUrl); // Limpia la URL del objeto
    } catch (error) {
      console.error('Error downloading the image:', error);
    }
  };

  //Funcion que abre y cierra el modal del formulario de contenidos
  const toggleModalContenidosForm = (params) => {
    setModalStateContenidosForm(!modalStateContenidosForm);
  };

  // Funcion que actualiza el listado de contenidos
  const onClickUpdateList = (id, meta_datos, tipo_contenidos) => {
    let rowsEdit = rows.map((valorActual, indice, arr) => {
      if (valorActual.id === id) {
        let rowConvertido = { ...valorActual, meta_datos: meta_datos, id_tipo_contenidos: tipo_contenidos.id, tipo_contenidos: tipo_contenidos.id + " - " + tipo_contenidos.detalle, }
        if (rowConvertido.save) {
          setUpdateImageSave((prev) => ({
            ...prev,
            [rowConvertido.id_digitalizaciones]: rowConvertido.meta_datos.map((meta) => ({
              id_tipo_contenidos: meta.id_tipo_contenidos?.toString() || '',
              valor: meta.valor || '-',
              id: rowConvertido.id_digitalizaciones,
              id_metadatos: meta.id,
              id_digitalizaciones_metadatos: meta.id_digitalizaciones_metadatos,
            })),
          }));
        }

        return rowConvertido;
      } else {
        return valorActual;
      }
    });

    setRows(rowsEdit);
    setMessage("Se han actualizado los metadatos");
    setSeverity("success");
    setSnackbarVisible(true);
    toggleModalContenidosForm();

  };


  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    if (newRow.save) {
      setUpdateImageSave({
        ...updateImageSave,
        [newRow.id_digitalizaciones]: {
          ...updateImageSave[
          newRow.id_digitalizaciones
          ],
          id_tipo_contenidos: newRow.id_tipo_contenidos.toString(),
          valor: newRow.descripcion,
          id: newRow.id_digitalizaciones,
        },
      });
    }
    return updatedRow;
  };


  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer style={{ padding: 10, display: 'flex', justifyContent: 'space-between' }}>

        <Grid>
          <GridToolbarColumnsButton
            style={{
              color: '#FFFFFF',
              fontFamily: 'Roboto, sans-serif',
              background: "#0A395F",
              margin: '4px',
              minWidth: '120px',
              width: '120px',
              fontSize: '11px',
              height: '30px',
            }}
          />
          <GridToolbarFilterButton
            style={{
              color: '#FFFFFF',
              fontFamily: 'Roboto, sans-serif',
              background: "#0A395F",
              margin: '4px',
              minWidth: '120px',
              width: '120px',
              fontSize: '11px',
              height: '30px',
            }}
          />
          <GridToolbarDensitySelector
            style={{
              color: '#FFFFFF',
              fontFamily: 'Roboto, sans-serif',
              background: "#0A395F",
              margin: '4px',
              minWidth: '120px',
              width: '120px',
              fontSize: '11px',
              height: '30px',
            }}
          />

          <GridToolbarExport style={{
            color: '#FFFFFF',
            fontFamily: 'Roboto, sans-serif',
            background: "#0A395F",
            margin: '4px',
            minWidth: '120px',
            width: '120px',
            fontSize: '11px',
            height: '30px',
          }} />

        </Grid>

      </GridToolbarContainer>
    );
  }


  return (
    <Box
      sx={{
        minHeight: 300,
        height: 550, // Establece la altura en auto para que se ajuste al contenido
        width: '100%',
        '& .actions': {
          color: 'text.secondary',
        },
        '& .textPrimary': {
          color: 'text.primary',
        },
      }}
    >
      <DataGridPro
        rows={rows}
        columns={columns}
        editMode="row"
        rowModesModel={rowModesModel}
        onRowModesModelChange={(newModel) => setRowModesModel(newModel)}
        onRowEditStart={handleRowEditStart}
        onRowEditStop={handleRowEditStop}
        processRowUpdate={processRowUpdate}
        componentsProps={{
          toolbar: { setRows, setRowModesModel },
          panel: { sx: estilosComponentGrilla }
        }}
        components={{ Toolbar: CustomToolbar }}
        localeText={esES.components.MuiDataGrid.defaultProps.localeText} // hace que la cabecera de los filtros este español
        experimentalFeatures={{ newEditingApi: true }}
        rowReordering
        onRowOrderChange={handleRowOrderChange}
        getRowHeight={() => 'auto'}
      />
      {desplegarImagen && (
        //Aca va el componente de busqueda
        <SimpleDialogComponent
          open={desplegarImagen}
          modalName={"Imagen"}
          child={
            <Grid>
              <Stack direction="row" spacing={2}>

                <Button
                  onClick={(params) => handleDownload(selectedImage)}
                  variant="contained" endIcon={<FileDownloadIcon />}>
                  Descargar Imagen
                </Button>
              </Stack>
              <Grid sx={{
                mt: 1, minWidth: "100%", textAlign: "center",
                wordBreak: "break-all"
              }}>
                <img src={selectedImage} alt="Imagen" />
              </Grid>
            </Grid>

          }
          // setPushData={onClickImagenesFacturas}
          handleClose={handleCloseImage}
          buttonEnviar={false}
          buttonCancelar={false}
          fullscreen={true}
        ></SimpleDialogComponent>
      )}

      {modalStateContenidosForm && (
        <SimpleDialogComponent
          open={modalStateContenidosForm}
          modalName={"Metadatos"}
          child={
            <TipoContenidosSelectMetadatos
              data={[]}
              toggleModalContenidosForm={toggleModalContenidosForm}
              tiposContenidos={tipoContenidoList}
              updateList={onClickUpdateList}
              // setLabelModal={setLabelModal}
              tipoContenidoSelect={tipoContenidoSelect}
              registroSeleccionado={registroSeleccionado}
              selectorCajas={true}
              digitalizado={true}
              ocrCampos={ocrCamposModal}
              ocrUmbral={ocrUmbral ?? 80}
              onOcrApply={onOcrApply}
            />
          }
          setPushData={toggleModalContenidosForm}
          handleClose={toggleModalContenidosForm}
          buttonEnviar={false}
          buttonCancelar={false}
        />
      )}
      <SnackbarMessenger
        open={snackbarVisible}
        message={message}
        severity={severity}
        close={() => {
          setSnackbarVisible(false);
        }}
      />
    </Box>
  );
}